import { FC, useRef } from 'react';
import { SvgIcon, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as IconWeChat } from 'src/assets/svg/wechat-logo.svg';

import { appConfig } from '../../../app/app-config';

import { ContactUsButton } from './contact-us-button';

export const OpenWechatButton: FC = () => {
    const { t } = useTranslation();
    const Icon = useRef(
        <SvgIcon>
            <IconWeChat />
        </SvgIcon>
    );

    return (
        <ContactUsButton icon={Icon.current} href={appConfig.contacts.weChatUrl} newTab>
            <Typography>{t('contact_us_open_wechat')}</Typography>
        </ContactUsButton>
    );
};
